import { useRef, useState, useLayoutEffect } from "react";

/**
 * Sliding-indicator behavior for a segmented control (e.g. All/Mandatory/
 * Custom). Returns a `tabRefs` object to attach to each option button via
 * `ref={(el) => { tabRefs.current[key] = el }}`, and the `left`/`width`
 * style to position the animated background behind the active option.
 */
export default function useSegmentedTabIndicator(activeKey, extraDeps = []) {
  const tabRefs = useRef({});
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

  useLayoutEffect(() => {
    const activeEl = tabRefs.current[activeKey];
    if (activeEl) {
      setIndicatorStyle({ left: activeEl.offsetLeft, width: activeEl.offsetWidth });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, ...extraDeps]);

  return { tabRefs, indicatorStyle };
}
